<template>
  <div class="">
    <div class="text-4xl p-8 text-center">ReviewIQ Pricing</div>
    <div class="flex justify-center my-4">
      <el-switch
        v-model="isYearly"
        active-color="#34EB4F"
        inactive-color="#D3DCE6"
        active-text="Bill Yearly (Save 10%)"
        inactive-text="Bill Monthly"
      ></el-switch>
    </div>
    <div class="w-full lg:flex md:px-8 md:justify-around">
      <PriceCard
        v-for="plan in plans"
        :title="plan.title"
        :bulletPoints="plan.bulletPoints"
        :color="plan.color"
        :priceColor="isYearly ? 'text-green-800' : 'text-slate-900'"
        :price="isYearly ? plan.yearlyPrice : plan.monthlyPrice"
        :link="isYearly ? plan.yearlyLink : plan.monthlyLink"
      />
    </div>
  </div>
</template>

<script setup>
import PriceCard from "@/views/HomeView/components/PriceCard.vue";
import { ref } from "vue";

const isYearly = ref(false);

const basicTierTitle = "Basic";
const basicTierBulletPoints = [
  "Create Review Pages",
  "Tailor Your Review Process",
  "Basic Review Tracking",
  "Basic Reports",
  "Email Support",
];

const proTierTitle = "Pro";
const proTierBulletPoints = [
  // "Custom Review Pages",
  // "Personalize Review Acquisition",
  "Everything in Basic",
  "Facilitate Secure Payments",
  "Detailed Review Tracking",
  // "Track Email Open Rates",
  "Execute Batch Operations",
  "Advanced Reports",
];

const eliteTierTitle = "Elite";
const eliteTierBulletPoints = [
  "Everything in Pro",
  "Personalize Review Requests",
  // "Facilitate Secure Payments",
  // "Monitor Review Submissions",
  // "Track Email Open Rates",
  "Comprehensive Analytics",
  "Developer Priority",
  "Early Access to New Features",
];

const plans = [
  {
    title: basicTierTitle,
    bulletPoints: basicTierBulletPoints,
    monthlyPrice: 249,
    yearlyPrice: 224,
    monthlyLink: "https://buy.stripe.com/8wM14EaXr7hhaYM288",
    yearlyLink: "https://buy.stripe.com/4gw7t29Tn7hh6Iw5kr",
  },
  {
    title: proTierTitle,
    bulletPoints: proTierBulletPoints,
    color: "green",
    monthlyPrice: 499,
    yearlyPrice: 449,
    monthlyLink: "https://buy.stripe.com/fZe28I1mRgRR1oc145",
    yearlyLink: "https://buy.stripe.com/4gw5kU9Tn6dd5EsaEK",
  },
  {
    title: eliteTierTitle,
    bulletPoints: eliteTierBulletPoints,
    color: "blue",
    monthlyPrice: 749,
    yearlyPrice: 674,
    monthlyLink: "https://buy.stripe.com/8wM6oY0iN9pp1oc7su",
    yearlyLink: "https://buy.stripe.com/8wM3cM2qVgRRaYM28b",
  },
];
</script>

<style scoped>
.card-container {
  min-width: 300px; /* Set the minimum width you want for your cards */
  flex: 1; /* This will allow the cards to be flexible but not smaller than min-width */
  padding: 1rem; /* Adjust as needed for spacing */
}

/* Media query for smaller screens */
@media (max-width: 768px) {
  /* Adjust the pixel value based on your design needs */
  .card-container {
    flex-basis: 100%; /* On small screens, take up 100% of the flex container width */
  }
}
</style>
